import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createVNode as _createVNode, Fragment as _Fragment, withCtx as _withCtx } from "vue";
const _hoisted_1 = { class: "skpLogin" };
const _hoisted_2 = ["src"];
const _hoisted_3 = ["innerHTML"];
const _hoisted_4 = { class: "skpLogin-buttons" };
const _hoisted_5 = ["innerHTML"];
const _hoisted_6 = { class: "skpLogin-buttons" };
const _hoisted_7 = { class: "skpLogin-buttons" };
import { ThemeButton, ThemeModal } from '../../../front/components';
import { ref } from 'vue';
import { theme } from '../../../front/Theme';
var Step;
(function (Step) {
    Step[Step["Landing"] = 0] = "Landing";
    Step[Step["Magazine"] = 1] = "Magazine";
})(Step || (Step = {}));
export default /*@__PURE__*/ _defineComponent({
    __name: 'Login',
    props: {
        data: {}
    },
    setup(__props, { expose: __expose }) {
        const step = ref(Step.Landing);
        const modal = ref();
        __expose({
            show,
        });
        function show() {
            var _a;
            (_a = modal.value) === null || _a === void 0 ? void 0 : _a.show();
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(_unref(ThemeModal), {
                ref_key: "modal",
                ref: modal,
                "wca-title": "Skolporten login"
            }, {
                default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_1, [
                        _createElementVNode("header", null, [
                            _createElementVNode("img", {
                                src: _unref(theme)().getUri('assets/images/skolporten-logo-primary.png'),
                                alt: "Skolporten logo"
                            }, null, 8, _hoisted_2),
                            (step.value > Step.Landing)
                                ? (_openBlock(), _createBlock(_unref(ThemeButton), {
                                    key: 0,
                                    icon: "arrow-left-long",
                                    fill: "outline",
                                    color: "neutral",
                                    "aria-label": "Tillbaka",
                                    title: "Tillbaka",
                                    size: "small",
                                    onClick: _cache[0] || (_cache[0] = ($event) => (step.value = Step.Landing))
                                }))
                                : _createCommentVNode("", true)
                        ]),
                        _cache[4] || (_cache[4] = _createElementVNode("hr", null, null, -1)),
                        (step.value === Step.Landing)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _cache[2] || (_cache[2] = _createElementVNode("div", { class: "skpLogin-title" }, "Välj inloggningstyp", -1)),
                                (_ctx.data.landingDescription)
                                    ? (_openBlock(), _createElementBlock("div", {
                                        key: 0,
                                        class: "skpLogin-content richContent",
                                        innerHTML: _ctx.data.landingDescription
                                    }, null, 8, _hoisted_3))
                                    : _createCommentVNode("", true),
                                _createElementVNode("div", _hoisted_4, [
                                    _createVNode(_unref(ThemeButton), {
                                        title: "Digitala kurser",
                                        type: "link",
                                        href: _ctx.data.coursesPageUrl,
                                        target: "_blank",
                                        icon: "external-resource",
                                        color: "secondary",
                                        fill: "solid"
                                    }, null, 8, ["href"]),
                                    _createVNode(_unref(ThemeButton), {
                                        title: "Skolportens magasin",
                                        icon: "arrow-right-long",
                                        color: "primary",
                                        fill: "solid",
                                        onClick: _cache[1] || (_cache[1] = ($event) => (step.value = Step.Magazine))
                                    })
                                ])
                            ], 64))
                            : _createCommentVNode("", true),
                        (step.value === Step.Magazine)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                _cache[3] || (_cache[3] = _createElementVNode("div", { class: "skpLogin-title" }, "Skolportens magasin", -1)),
                                (_ctx.data.magazineDescription)
                                    ? (_openBlock(), _createElementBlock("div", {
                                        key: 0,
                                        class: "skpLogin-content richContent",
                                        innerHTML: _ctx.data.magazineDescription
                                    }, null, 8, _hoisted_5))
                                    : _createCommentVNode("", true),
                                _createElementVNode("div", _hoisted_6, [
                                    _createVNode(_unref(ThemeButton), {
                                        title: "Se app i App Store",
                                        type: "link",
                                        href: _ctx.data.magazineAppStoreUrl,
                                        target: "_blank",
                                        icon: "external-resource",
                                        color: "neutral",
                                        fill: "outline"
                                    }, null, 8, ["href"]),
                                    _createVNode(_unref(ThemeButton), {
                                        title: "Se app i Google Play",
                                        type: "link",
                                        href: _ctx.data.magazineGooglePlayUrl,
                                        target: "_blank",
                                        icon: "external-resource",
                                        color: "neutral",
                                        fill: "outline"
                                    }, null, 8, ["href"])
                                ]),
                                _createElementVNode("div", _hoisted_7, [
                                    _createVNode(_unref(ThemeButton), {
                                        title: "Läs i din dator",
                                        type: "link",
                                        href: _ctx.data.magazineUrl,
                                        target: "_blank",
                                        icon: "external-resource",
                                        color: "primary",
                                        fill: "solid"
                                    }, null, 8, ["href"])
                                ])
                            ], 64))
                            : _createCommentVNode("", true)
                    ])
                ]),
                _: 1
            }, 512));
        };
    }
});
